import { ColumnDef, ColumnDefResolved } from '@tanstack/react-table';

export type MetadataColumn<T = unknown> = ColumnDef<T> & Pick<ColumnDefResolved<T>, 'accessorKey'>;

export const mergeColumns = <T>({
  defaultColumns,
  customColumns = [],
}: {
  defaultColumns: MetadataColumn<T>[];
  customColumns?: MetadataColumn<T>[];
}): MetadataColumn<T>[] => {
  const defaultColumnsMap = new Map(defaultColumns.map((col) => [col.accessorKey, col]));
  const customColumnsMap = new Map(customColumns.map((col) => [col.accessorKey, col]));

  if (customColumns.length !== customColumnsMap.size || defaultColumns.length !== defaultColumnsMap.size) {
    throw new Error('Columns must have unique "accessorKey"!');
  }

  const mergedColumnsMap = { ...Object.fromEntries(defaultColumnsMap), ...Object.fromEntries(customColumnsMap) };

  return Object.values(mergedColumnsMap);
};
